module.exports = require('./helpers/bundle-url').getBundleURL('5VCOe') + "logo-dark.eefe0b7f.svg";